<template>
  <unicom-linha style="margin-bottom: 24px">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Outros</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="5" :class="espacamentoMobile" v-show="clickSwitch">
      <unicom-campo-texto
        ladoIcone="direito"
        :maxCaracteres="1500"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Outros"
        v-model="payload.especialidadesOferecidas"
        :mensagemErro="errorsServicos.campoOutrosOutros"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import SharedMixin from "@/views/RecursosPropriosQuestionarios/CentroMultiprofissional/componentes/CartaoInformacoesServicos/components/SharedMixin";
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/CentroMultiprofissional/componentes/CartaoInformacoesServicos/ServicosMixin";

export default {
  mixins: [SharedMixin, ServicosMixin],
  data() {
    return {
      payload: {
        tipoServico: "Outros",
        especialidadesOferecidas: "",
        tipoServicoPublico: []
      }
    };
  },
  watch: {
    "payload.tipoServicoPublico": `emitir`,
    "payload.especialidadesOferecidas": `emitir`,
    dadosServidor(newVal) {
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico || servico.especialidadesOferecidas)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.adicionar-campo {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  background: #00995d;
  text-align: center;
  font-size: 2rem;
  color: #fff;
  border-radius: 50%;
}
.pack-de-forms {
  margin-bottom: 1rem;
}
</style>
